import React, { useContext } from 'react';
import { Star, StarBorder } from "@mui/icons-material";
import { useTranslation } from "react-i18next";
import { MenuButtonStyle } from './styles';
import { DashboardContext } from '../../DashboardContext';
import ToolButton from '../../../../components/ToolButton';

const FavouriteDashboard = () => {
    const { t } = useTranslation();
    const { currentDashboard, toggleFavourite } = useContext(DashboardContext);

    return (
        <ToolButton
            hideTextOnMobileView={false}
            buttonStyle={{
                ...MenuButtonStyle,
                ...(currentDashboard?.dashboard.favourite
                    ? {
                        color: 'primary.main',
                    }
                    : {
                        color: 'text.secondary',
                        backgroundColor: 'background.paper',
                    }),
            }}
            iconElement={
                currentDashboard?.dashboard?.favourite ?
                    <Star /> :
                    <StarBorder />
            }
            onClick={() => toggleFavourite()}
            text={currentDashboard?.dashboard?.favourite ?
                t('screens.dashboarding.favourite') :
                t('screens.dashboarding.addToFavourites')
            }
            tooltip={t('screens.dashboarding.favourite')}
            active={currentDashboard?.dashboard?.favourite}
        />
    );
}

export default FavouriteDashboard;
